import React from 'react';

// CSS-drawn circle for the Fulfilment Progress Circle pattern (see
// ui-architecture.md) — none/partial/full, shared by SalesOrdersTable.js's
// Picked/Packed/Shipped columns and ShipConfirmSummary.js's per-line
// outcome marker. Not the ○/◐/● glyph trio: filled glyphs like ● are
// optically scaled down by most fonts relative to outline glyphs like ○,
// so the "fully done" dot rendered visibly smaller than the empty/partial
// ones at any font-size. A fixed-size div keeps all three states the same
// size regardless of font.
const SIZE = { sm: 14, md: 18 };

// onClick is optional — every existing consumer (Sales Orders' Picked/
// Packed/Shipped columns, Ship Confirm's per-line marker) renders a plain
// static dot. Only a consumer that passes it gets the button treatment
// (pointer cursor, no native button chrome) so the dot doubles as a link
// to wherever the underlying data is edited.
function ProgressDot({ state, title, size = 'sm', onClick }) {
  const dim = SIZE[size] || SIZE.sm;
  const base = {
    display: 'inline-block',
    width: dim,
    height: dim,
    borderRadius: '50%',
    verticalAlign: 'middle',
    boxSizing: 'border-box',
  };
  const style =
    state === 'full'
      ? { ...base, background: '#1e7e34' }
      : state === 'partial'
      ? { ...base, border: '2px solid #c98a1f', background: 'linear-gradient(90deg, #c98a1f 50%, transparent 50%)' }
      : { ...base, border: '2px solid #aab2bd', background: '#fff' };
  if (onClick) {
    return <button type="button" onClick={onClick} title={title} style={{ ...style, padding: 0, border: style.border || 'none', cursor: 'pointer' }} />;
  }
  return <span style={style} title={title} />;
}

export default ProgressDot;
